import React from 'react';
import { Form, FormControl, ControlLabel, ButtonToolbar, FormGroup, Button, Checkbox, Radio, Col } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import '../../includes/custom/css/common.css';
import '../../includes/custom/css/form.css';
import SelectInput from './SelectInput';
import JapaneseDatePicker from './JapaneseDatePicker';
import { EMPTY_STRING, FIELD_PROPOSAL_STARTDATE, REGEX_DATE, DATE_FORMAT, FIELD_PROPOSAL_ENDDATE, MIN_DB_DATE_EXACT, MAX_DB_DATE_EXACT, DATETIME_FORMAT, FIELD_CHECKBOX_INDETERMINATE } from '../../utils/constants';
import AutoTextarea from 'react-textarea-autosize';

let FormTemplate = (props) => {
    const defaultForm = "form-default";
    const defaultField = "form-field";
    const defaultContent = "form-content";
    const noBorder = "no-border";
    const defaultInput = "form-input";
    const defaultComponentClass = "input";
    const defaultFileAccept = "*";
    const defaultControl = "form-label";
    const defaultButton = "button-common";
    const requiredInput = "required-input";
    const requiredNumber = "required-number";
    const mobileInput = "mobile-input";

    //renders radio component
    const RadioButtonInputs = (input) => (
        props.radioButtonInput && props.radioButtonInput.map((radio, i) => {
            if (radio.name === input.name) {
                return (
                    <Radio
                        key={i}
                        inline={input.inline}
                        value={radio.value}
                        name={radio.name}
                        onChange={props.handleInputChange}
                        checked={props[radio.name] === (radio.value)}
                        disabled={props.editMode && (input.disabled || props.disabled || (props.default && input.hasDefault))}
                        className={[input.className, defaultInput]}
                    >
                        <span className="mt-10 min-width-50">{radio.label}</span>
                    </Radio>
                )
            }
            return EMPTY_STRING;
        })
    );

    //renders checkbox component
    const CheckboxInputs = (input) => (props.checkBoxInput &&
        props.checkBoxInput.map((checkbox, i) => {
            if (checkbox.name === input.name) {
                return (
                    <Checkbox
                        key={i}
                        inline={input.inline}
                        value={checkbox.value}
                        name={checkbox.name}
                        onChange={input.disabled || props.disabled ? () => { } : props.handleCheckboxChange}
                        checked={props[checkbox.name].includes(checkbox.value)}
                        disabled={input.disabled || props.disabled}
                    >
                        {checkbox.label}
                    </Checkbox>
                )
            }
            return "";
        })
    );

    function RenderInput(input) {
        let customClassName = EMPTY_STRING;

        if (true === input.required) {
            customClassName = [defaultControl]
        } else if (true === input.requiredNum) {
            customClassName = [requiredNumber, defaultControl]
        } else {
            customClassName = defaultControl
        }

        if (!props.default && input.optional) {
            customClassName = defaultControl
        }

        switch (input.type) {
            //renders radio buttons
            case "static": {
                return (
                    <FormGroup key={input.name} className={defaultField}>
                        <ControlLabel className={customClassName}><span className={input.required && requiredInput}>{input.label}</span></ControlLabel>
                        <FormControl.Static>{props[input.name]}</FormControl.Static>
                    </FormGroup>
                );
            }

            //renders radio buttons
            case "radio": {
                return (
                    <FormGroup key={input.name} className={defaultField} validationState={input.validationState}>
                        <Col lg={4} md={5} className={customClassName}><span className={input.required && requiredInput}>{input.label}</span></Col>
                        <Col lg={8} md={7} className={["form-radio", defaultContent]}>
                            {input.inline ? " " : <br />}
                            {RadioButtonInputs(input)}
                        </Col>
                    </FormGroup>
                );
            }

            //renders checkboxes
            case "checkbox": {
                return (
                    <FormGroup key={input.name} className={defaultField} validationState={input.validationState}>
                        <ControlLabel className={customClassName}><span className={input.required && requiredInput}>{input.label}</span></ControlLabel>
                        {input.inline ? <br /> : ""}
                        {CheckboxInputs(input)}
                    </FormGroup>
                );
            }

            //renders select input
            case "select": {
                return (
                    <FormGroup key={input.name} className={defaultField} validationState={input.validationState}>
                        <Col lg={4} md={5} className={customClassName}><span className={input.required && requiredInput}>{input.label}</span></Col>
                        <Col lg={8} md={7} className={defaultContent}>
                            <SelectInput
                                componentClass={input.componentClass ? input.componentClass : defaultComponentClass}
                                name={input.name}
                                value={props[input.name]}
                                onChange={input.disabled || props.disabled ? () => { } : props.handleInputChange}
                                disabled={input.disabled || props.disabled}
                                className={[input.className, defaultInput]}
                                selectInput={props.selectInput}
                                placeholder={input.placeholder}
                            />
                        </Col>
                    </FormGroup>
                );
            }

            //renders file upload
            case "file": {
                return (
                    <FormGroup key={input.name} className={defaultField} validationState={input.validationState}>
                        <ControlLabel className={customClassName}><span className={input.required && requiredInput}>{input.label}</span></ControlLabel>
                        <FormControl
                            type={input.type}
                            name={input.name}
                            onChange={props.handleInputChange}
                            required={input.required}
                            disabled={input.disabled || props.disabled}
                            className={input.className}
                            accept={input.accept ? input.accept : defaultFileAccept}
                        />
                    </FormGroup>
                );
            }

            //renders datepicker field
            case "datepicker": {
                return (
                    <FormGroup key={input.name} className={defaultField} validationState={input.validationState}>
                        <Col lg={4} md={5} className={customClassName}><span className={input.required && requiredInput}>{input.label}</span></Col>
                        <Col lg={8} md={7} className={defaultContent}>
                            <JapaneseDatePicker
                                name={input.name}
                                selected={moment(props[input.name], input.format)}
                                onChange={props.handleDateChange.bind(this, input.name, input.format)}
                                placeholderText={input.placeholder}
                            />
                        </Col>
                    </FormGroup>
                );
            }

            //renders textarea with large height
            case "high-textarea": {
                return (
                    <FormGroup key={input.name} className={input.bgGreen ? ["auto-height mb-0 bg-green bottom-border-white"] : ["auto-height bg-transparent bottom-border-white"]} validationState={input.validationState}>
                        <Col lg={props.mobile ? 12 : 4} md={props.mobile ? 12 : 5} className={[customClassName, noBorder]}><span className={input.required && requiredInput}>{input.label}</span></Col>
                        <Col lg={props.mobile ? 12 : 8} md={props.mobile ? 12 : 7} className={props.mobile ? [mobileInput] : [defaultContent, "auto-height"]}>
                            <AutoTextarea
                                type={input.type}
                                placeholder={input.placeholder}
                                minLength={input.minLength}
                                maxLength={input.maxLength}
                                maxRows={120}
                                name={input.name}
                                value={props[input.name]}
                                onChange={props.handleInputChange}
                                disabled={(input.disabled || props.disabled)
                                    || ((props.editMode) && ((props.default && input.hasDefault) || input.readOnly))
                                }
                                className={input.className}
                            />
                        </Col>
                    </FormGroup>
                );
            }

            //renders custom for send date time
            case "sendDateTime": {
                return (
                    <FormGroup key={input.name} className={defaultField} validationState={input.validationState}>
                        <Col lg={props.mobile ? 12 : 4} md={props.mobile ? 12 : 5} className={customClassName}><span className={input.required && requiredInput}>{input.label}</span></Col>
                        <Col lg={props.mobile ? 12 : 8} md={props.mobile ? 12 : 7} className={props.mobile ? [defaultContent, mobileInput] : defaultContent}>
                            <FormControl
                                type={input.type}
                                componentClass={input.componentClass ? input.componentClass : defaultComponentClass}
                                placeholder={input.placeholder}
                                name={input.name}
                                value={EMPTY_STRING === props[input.name] ? EMPTY_STRING : moment(props[input.name]).format(DATETIME_FORMAT)}
                                onChange={input.disabled || props.disabled ? () => { } : props.handleInputChange}
                                disabled={input.disabled || props.disabled}
                                readOnly={props.editMode && ((props.default && input.hasDefault) || input.readOnly)}
                                className={[input.className, defaultInput]}
                            />
                        </Col>
                    </FormGroup>
                );
            }

            //renders custom for distributor
            case "distributor": {
                return (
                    <FormGroup key={"distributor"} className={["auto-height bg-green"]} validationState={input.validationState}>
                        <Col lg={4} md={5} className={[customClassName, noBorder]}>
                            <div className="flex-align-center">
                                {input.label}
                                <span className="required-field">  *</span>

                                <Checkbox
                                    id={FIELD_CHECKBOX_INDETERMINATE}
                                    checked={props.hasGroupSelected}
                                    onChange={props.handleParentCheckboxChange.bind(this, props.hasGroupSelected)}
                                    onClick={props.handleParentCheckboxChange.bind(this, props.hasGroupSelected)}
                                    className={props.disabled ? "hide" : "form-checklist"}
                                />
                            </div>
                        </Col>
                        <Col lg={8} md={7} className={[defaultContent, "border-gray auto-height "]} id="distributor-content">
                            {props.distributorComponent}
                        </Col>
                    </FormGroup>
                );
            }

            //renders text, textarea, email, password, numbers, default input
            default: {
                let disabled = input.disabled || props.disabled
                let readOnly = props.editMode && ((props.default && input.hasDefault) || input.readOnly)
                return (
                    <FormGroup key={input.name} className={defaultField} validationState={input.validationState}>
                        <Col lg={props.mobile ? 12 : 4} md={props.mobile ? 12 : 5} className={customClassName}><span className={input.required && requiredInput}>{input.label}</span></Col>
                        <Col lg={props.mobile ? 12 : 8} md={props.mobile ? 12 : 7} className={props.mobile ? [defaultContent, mobileInput] : defaultContent}>
                            <FormControl
                                type={input.type}
                                componentClass={input.componentClass ? input.componentClass : defaultComponentClass}
                                placeholder={input.placeholder}
                                minLength={input.minLength}
                                maxLength={input.maxLength}
                                max={input.max}
                                min={input.min}
                                name={input.name}
                                value={props[input.name]}
                                onChange={disabled || readOnly ? () => { } : props.handleInputChange}
                                disabled={disabled}
                                readOnly={readOnly}
                                className={[input.className, defaultInput]}
                            />
                        </Col>
                    </FormGroup>
                );
            }
        }

    }

    //Maps form inputs
    const FormInputs = props.formInputs && props.formInputs.map((input) => {
        return RenderInput(input)
    });

    //Renders form buttons
    const FormButtons = props.formButtons && props.formButtons.map((button, i) => {
        if (button.conditional) {
            if (props.editMode) {
                return (
                    <Button key={i} className={[button.className, defaultButton]} disabled={button.disabled} bsStyle={button.bsStyle} bsSize={button.bsSize} onClick={button.onClick}>
                        {button.label}
                    </Button>
                );
            } else {
                return EMPTY_STRING;
            }
        } else {
            return (
                <Button key={i} className={[button.className, defaultButton]} disabled={button.disabled} bsStyle={button.bsStyle} bsSize={button.bsSize} onClick={button.onClick} type={button.submit ? "submit" : "button"}>
                    {button.label}
                </Button>
            );
        }
    });

    //Custom for proposal start and end date input
    const ProposalDateInput = props.proposalDates && (
        <FormGroup className="mb-30">
            <Col sm={4} className={defaultControl}>{"提案期間"}</Col>
            <Col sm={8} className={[defaultContent, "bg-base"]}>
                <Col sm={5} className="modal-field">
                    <JapaneseDatePicker
                        onChangeRaw={props.handleDateChangeRaw}
                        name={FIELD_PROPOSAL_STARTDATE}
                        selected={(props[FIELD_PROPOSAL_STARTDATE]).match(REGEX_DATE) && !(MIN_DB_DATE_EXACT >= props[FIELD_PROPOSAL_STARTDATE]) ? moment(props[FIELD_PROPOSAL_STARTDATE], DATE_FORMAT) : null}
                        className="modal-datepicker"
                        onChange={props.handleDateChange.bind(this, FIELD_PROPOSAL_STARTDATE, DATE_FORMAT)}
                        disabled={true}
                        noIcon={true}
                        bordered={true}
                    />
                </Col>

                <Col sm={2} className="modal-separator bg-white">〜</Col>

                <Col sm={5} className="modal-field">
                    <JapaneseDatePicker
                        onChangeRaw={props.handleDateChangeRaw}
                        name={FIELD_PROPOSAL_ENDDATE}
                        selected={(props[FIELD_PROPOSAL_ENDDATE]).match(REGEX_DATE) && !(MAX_DB_DATE_EXACT <= props[FIELD_PROPOSAL_ENDDATE]) ? moment(props[FIELD_PROPOSAL_ENDDATE], DATE_FORMAT) : null}
                        className="modal-datepicker"
                        onChange={props.handleDateChange.bind(this, FIELD_PROPOSAL_ENDDATE, DATE_FORMAT)}
                        disabled={true}
                        noIcon={true}
                        bordered={true}
                    />
                </Col>
            </Col>
        </FormGroup>
    )

    const form = (
        <Form noValidate={true} onSubmit={props.handleSubmit} className={[props.className, defaultForm]} horizontal={props.horizontal}>
            {ProposalDateInput}
            {FormInputs}
        </Form>
    )

    return (
        <div>
            {props.mobile || props.xs ?
                form :
                <div>
                    <Col md={3} />
                    <Col md={6}>
                        {form}
                    </Col>
                    <Col md={3} />
                    <ButtonToolbar className={[defaultField, "fixed-toolbar"]}>
                        {FormButtons}
                    </ButtonToolbar>
                </div>}

        </div>
    );
}

export default FormTemplate;